// extracted by mini-css-extract-plugin
module.exports = {"I":"I_I__PECUZ"};